module.exports = __webpack_public_path__ + "static/media/mobilephone.08550e51.svg";